


// Generated from io.spcfy.iv3.services.sentry.TypedError$TypedErrorTypes

export type TypedErrorTypesKey =
  "TYPED_ERROR";


export interface TypedErrorTypesDTO {
  key: TypedErrorTypesKey;    
}


export const TypedErrorTypess: Record<TypedErrorTypesKey, TypedErrorTypesDTO> = {
  TYPED_ERROR: { key: "TYPED_ERROR",  }
};
